export const AppConfig = {
    public_bucket_name: 'testing.env.main.public',
    s3_base_endpoint: 'https://s3.amazonaws.com/',
    api_endpoint: 'https://z79mpjvvt8.execute-api.us-east-1.amazonaws.com/vpncred'
  };
